import Vue from 'vue';
import Router from 'vue-router';
import _ from 'lodash';
import helpers from '@/libs/helpers';

// import async from 'async';
// import store from '@/store';

// Views
import MainLayout from '@/pages/main';
import AuthView from '@/pages/auth';
// import CompanyView from '@/pages/company';
import ErrorView from '@/pages/error';
// import BillerView from '@/pages/biller';
// import Hello from '@/components/Hello';

// Routes
import adminRoutes from './routes/admin';
import billerRoutes from './routes/biller';

// Middleware
import mid from './middleware';

Vue.use(Router);

const defaultRouteName = window.appConfig.SCB_BILLING_APP_MODE === 'admin' ?
  process.env.DEFAULT_ROUTE_NAME : process.env.DEFAULT_BILLER_ROUTE_NAME;

const defaultRoutes = [
  // Auth Stuffs
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: AuthView.resetPassword,
    beforeEnter: mid.requireAuthenticated,
    meta: {
      title: 'เปลี่ยนรหัสผ่าน',
    },
  },
];
const routes = _.concat(
  defaultRoutes,
  window.appConfig.SCB_BILLING_APP_MODE === 'admin' ?
    adminRoutes : billerRoutes,
);
const slug = helpers.getURLSlug();
const base = slug === '' ? '/' : `/${slug}/`;

const router = new Router({
  base,
  mode: process.env.ROUTER_MODE,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: AuthView.login,
      beforeEnter: mid.checkIsLogin,
      meta: {
        title: 'เข้าสู่ระบบ',
      },
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: AuthView.forgotPassword,
      beforeEnter: mid.checkIsLogin,
      meta: {
        title: 'ลืมรหัสผ่าน',
      },
    },
    {
      path: '/logout',
      name: 'Logout',
      component: AuthView.logout,
      beforeEnter: mid.requireAuthenticated,
      meta: {
        title: 'ออกจากระบบ',
      },
    },
    {
      path: '/reset-password-with-token',
      props: true,
      name: 'ResetPasswordWithToken',
      component: AuthView.resetPasswordWithToken,
      meta: {
        title: 'เปลี่ยนรหัสผ่าน',
      },
    },
    {
      path: '/',
      name: 'MainLayout',
      component: MainLayout,
      redirect: { name: defaultRouteName },
      children: routes,
    },
    {
      path: '*',
      redirect: { name: defaultRouteName },
    },
    // Error
    {
      path: '/unauthorized',
      name: 'UnauthorizedError',
      component: ErrorView.unauthorized,
      meta: {
        title: 'ไม่อนุญาต',
      },
    },
  ],
});
router.beforeEach(mid.pageTitle);
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js